import React from 'react'

import bread3 from "../images/no-image.jpg"
import fishball from "../images/products/fishball.jpg"
import kikiam from "../images/products/kikiam.jpg"
import kwekkwek from "../images/products/kwekkwek.jpg"
import kwekkwekfinal from "../images/products/kwekkwekfinal.jpg"
import mixed from "../images/products/mixed-fb-sb.jpg"
import chickensiomai from "../images/products/chicken-siomai.jpg"
import squidball from "../images/products/squid-ball.jpg"

import hchickensiomai from "../images/products/hi-res/chicken-siomai.jpg"
import hfishball from "../images/products/hi-res/fishball.jpg"
import hkikiam from "../images/products/hi-res/kikiam.jpg"
import hkwekkwekfinal from "../images/products/hi-res/kwekkwekfinal.jpg"
import hmixed from "../images/products/hi-res/mixed-fb-sb.jpg"
import hsquidball from "../images/products/hi-res/squid-ball.jpg"
import hkwekkwek from "../images/products/hi-res/kwekkwek.jpg"

const KMiniBites = ({ title, data }) => (
    <div className="menu-list text-center">
        <h3 className="font-title inline menu--list__title mt-10 mx-auto pb-1 text-center">{title}</h3>
        <div className="flex flex-wrap">
            <div className="w-full md:w-1/3 lg:w-1/3 xl:w-1/3 xl:mt-6 product--lists xl:px-10">
                <ul className="mx-5 my-5">
                    {data.filter(col => col.column == '1').map((prod) => <li className="flex flex-wrap justify-between text-left items-center mb-3 pb-2 border-dashed border-b ">
                        <div className=" w-3/4">
                            <p className="product__name ml-2">{prod.productName}</p>
                        </div>
                        <a href="#" data-lity-target='' data-lity className="w-1/5">{prod.productImage !== null ? <img src={prod.productThumbImage.file.url} class="rounded" /> : <img src={bread3} class="rounded" />}</a>
                    </li>)}
                </ul>
            </div>
            <div className="w-full md:w-1/3 lg:w-1/3 xl:w-1/3 xl:mt-6 product--lists xl:px-10">
                <ul className="mx-5 my-5">
                    {data.filter(col => col.column == '2').map((prod) => <li className="flex flex-wrap justify-between text-left items-center mb-3 pb-2 border-dashed border-b ">
                        <div className=" w-3/4">
                            <p className="product__name ml-2">{prod.productName}</p>
                        </div>
                        <a href="#" data-lity-target='' data-lity className="w-1/5">{prod.productImage !== null ? <img src={prod.productThumbImage.file.url} class="rounded" /> : <img src={bread3} class="rounded" />}</a>
                    </li>)}
                </ul>
            </div>
            <div className="w-full md:w-1/3 lg:w-1/3 xl:w-1/3 xl:mt-6 product--lists xl:px-10">
                <ul className="mx-5 my-5">
                    {data.filter(col => col.column == '3').map((prod) => <li className="flex flex-wrap justify-between text-left items-center mb-3 pb-2 border-dashed border-b ">
                        <div className=" w-3/4">
                            <p className="product__name ml-2">{prod.productName}</p>
                        </div>
                        <a href="#" data-lity-target='' data-lity className="w-1/5">{prod.productImage !== null ? <img src={prod.productThumbImage.file.url} class="rounded" /> : <img src={bread3} class="rounded" />}</a>
                    </li>)}
                </ul>
            </div>
        </div>
    </div>
)

export default KMiniBites